import type {PropertyMap} from "../../common/utils/objects";
import type {Nullable} from "../../bootstrap/common/types";

export const CONFIRMABLE_CHANNELS: string[] = [
    "youtube"
];

export const TAG_LIMIT = 3;

export const ICON_IDS: PropertyMap = {
    facebook: "socialicon_facebook",
    twitter: "socialicon_twitter",
    linkedin: "socialicon_linkedin",
    instagram: "socialicon_instagram",
    youtube: "socialicon_youtube",
    press: "press"
};

export type FeedChannel = {
    width?: FeedChannelWidth;
}

export type FeedChannelWidth = "small" | "large" | "double";

export function simpleFeedChannelMap(channels: Nullable<string[]>): PropertyMap<FeedChannel> {
    const channelMap: PropertyMap<FeedChannel> = {};
    channels?.forEach(channel => {
        channelMap[channel] = {};
    });
    return channelMap;
}